import { styled } from 'stitches.config'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { Button } from 'components/Button'
import { SliderContainer } from 'features/components/ReviewSlider/ReviewSlider.styles'

export const ExploreMoreRoot = styled('div', {
  width: '100%',
  background: '$accent-white',
  padding: '64px $2',
  display: 'flex',
  flexDirection: 'column',
  '@bp2': {
    padding: '94px $2',
  },
})

export const Title = styled(Text, {
  width: '100%',
  margin: 'auto',
  maxWidth: '400px',
  '@bp2': {
    maxWidth: 'none',
  },
})

export const Features = styled('div', {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '0',
  marginTop: '$2',
  flexWrap: 'wrap',
  '@bp1': {
    gap: '$3',
    justifyContent: 'center',
  },
  '@bp2': {
    gap: '$6',
    marginTop: '$3',
  },
})

export const Feature = styled(Stack, {
  width: '50%',
  marginTop: '12px',

  '@bp1': {
    width: 'auto',
    margin: 0,
  },
})

export const LearnMoreCard = styled('div', {
  border: '1px solid $accent-gray',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  borderRadius: '8px',
  padding: '16px 20px',
  width: '100%',
  maxWidth: '249px',

  '& > button': {
    border: '1px solid $primary-500',
  },

  '@bp2': {
    maxWidth: '363px',
  }
})

export const CopyColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '204px',
  '@bp2': {
    alignItems: 'flex-start',
  },
})

export const LearnMoreButton = styled(Button, {
  height: '42px',
  width: '100%',
  marginTop: '$2',

  '@bp2': {
    marginTop: '$1',
  },
})

export const ImageCopy = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '16px',
  '@bp2': {
    flexDirection: 'row',
  },
})

export const ExploreMoreSlider = styled(SliderContainer, {
  textAlign: 'center',
  marginTop: '$5',
  position: 'relative',

  '& .slick-prev': {
    height: '0px',
    width: '0px',
  },

  '& .slick-next': {
    height: '0px',
    width: '0px',
  },

  '& .slick-dots li button:before': {
    border: `2px solid $primary-500`,
  },

  '& .slick-dots li.slick-active button:before': {
    backgroundColor: `$primary-500`,
  },

  '& .slick-dots': {
    bottom: '-20px',
  },

  '@mobile': {
    '& .slick-prev': {
      left: '-10px',
      height: '50px',
      width: '50px',
    },
  
    '& .slick-next': {
      right: '-10px',
      height: '50px',
      width: '50px',
    },
  },

  '@bp2': {
    maxWidth: '1150px',

    '& .slick-dots': {
      bottom: '-50px',
    },

    '& .slick-prev': {
      height: '0px',
      width: '0px',
    },

    '& .slick-next': {
      height: '0px',
      width: '0px',
    },
  },

  '@bp3': {
    '& .slick-prev': {
      left: '0px',
      width: '0px',
      height: '0px',
    },

    '& .slick-next': {
      right: '0px',
      width: '0px',
      height: '0px',
    },
  },

  '@bp3_1': {
    '& .slick-prev': {
      left: '-90px',
      width: '80px',
      height: '80px',
    },

    '& .slick-next': {
      right: '-90px',
      width: '80px',
      height: '80px',
    },
  },
})

export const ImageWrapper = styled('div', {
  width: '110px',
  height: '154px',
  position: 'relative',
  '@bp2': {
    width: '93px',
    height: '130px',
  },
})
